import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import { ModalProps } from "../types";

export default function Modals({
  showDialog,
  onCloseDialog,
  title,
  width,
  height,
  isLoading,
  className,
  children,
  centerTitle,
  backButton,
  subtitle,
}: ModalProps & { subtitle?: string }) {
  const navigate = useNavigate();
  const getStyles = () => {
    const styles: React.CSSProperties = {};

    if (width) {
      styles.width = `${width}px`;
    }

    if (height) {
      styles.height = `${height}px`;
    }

    return styles;
  };
  return (
    <div className="bg-background max-h-[90vh] overflow-y-auto fixed w-full max-sm:px-3">
      <div
        style={getStyles()}
        className="bg-surface border border-edge block mx-auto mt-8 mb-10 max-sm:mt-4 z-10 rounded-2xl shadow-card max-w-full"
      >
        {/* Header: back, title and subtitle on one line, pinned so they stay
            reachable through a long form. The old version stacked a floating "Back"
            above the card and centred an uppercase 16px title in an 80px band —
            a lot of vertical space spent before the first field. */}
        <div className="sticky top-0 z-20 flex items-center gap-3 px-6 max-sm:px-4 py-4 border-b border-edge bg-surface rounded-t-2xl">
          {backButton ? (
            <button
              type="button"
              onClick={() => navigate(-1)}
              aria-label="Go back"
              title="Go back"
              className="shrink-0 h-9 w-9 rounded-lg flex items-center justify-center border border-edge bg-overlay text-light-gray hover:text-text-primary hover:border-indigo-400/40 transition-all duration-200 cursor-pointer"
            >
              <FontAwesomeIcon icon={faArrowLeft} className="text-[13px]" />
            </button>
          ) : null}

          <div className="min-w-0">
            <h2
              className={clsx(
                "text-[20px] font-bold text-text-primary leading-tight",
                centerTitle && !backButton && "text-center"
              )}
            >
              {title}
            </h2>
            {subtitle ? (
              <p className="mt-1 text-[13px] font-medium text-light-gray truncate">
                {subtitle}
              </p>
            ) : null}
          </div>
        </div>

        <div className={className}>{children}</div>
      </div>
    </div>
  );
}
